import { Box } from "@mui/material";

/**
 * Route/chunk fallback — no spinner; keeps app background to avoid white flash.
 * Header API loader (GenericHeader) handles fetch/save states.
 */
const PageLoader = () => (
  <Box
    aria-busy="true"
    aria-label="Loading page"
    sx={{
      minHeight: "100vh",
      bgcolor: "background.default",
    }}
  />
);

export default PageLoader;
